import { List } from "immutable";
import _ from "lodash";
import moment from "moment";
import * as React from "react";
import { ReviewersEditor } from "./components";
import * as Comp from "../../../components";
import { ComponentWithValidatedForm } from "../../../components/validation";
import { Statuses } from "../../../domain";
import * as Forms from "../../../forms";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { Utility, DateHelper } from "../../../utils";

interface OwnProps {
    api: Api;
    cancelLink: JSX.Element;
    eventId: number;
    onSubmit: (model: Forms.Abstract.GradingGroupData, body: any) => void;
    parentGroups: List<M.Abstract.GradingGroup>;
}

interface OwnState {
}

export class EditGroupForm extends ComponentWithValidatedForm<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.Abstract.GradingGroup();
        this.state = {
            ...this.getInitialState(formModel),
        };
    }

    public setFormData(data: M.Abstract.GradingGroup) {
        const formModel = this.getFormModelData<Forms.Abstract.GradingGroupData>();
        formModel.active = Statuses.isActive(data.statusId),
        formModel.closesOn = Utility.fromApiDate(data.closesOnServer) || null;
        formModel.id = data.id;
        formModel.isAdmin = data.isAdminGroup;
        formModel.name = data.name;
        formModel.parent = data.parent && data.parentId
            ? { label: data.parent || "", value: data.parentId }
            : null,
        formModel.reviewers = _.orderBy(data.reviewers, ["user.firstName", "user.lastName"]).map((x, i) => ({
            degrees: x.member.degrees,
            firstName: x.member.firstName || "",
            index: i,
            isDeleted: false,
            isNew: false,
            lastName: x.member.lastName || "",
            legacyMemberId: x.member.legacyMemberId,
            profilePicture: x.member.profilePicture,
            userId: x.userId,
            username: x.member.username || "",
        }));
        formModel.opensOn = Utility.fromApiDate(data.opensOnServer) || null;

        this.updateFormModelData(formModel);
    }

    public render() {
        return <Comp.Validation.ValidatedForm
            formComponent={this}
            model={this.state.formModel.data}
            onValidSubmit={async (model) => this.handleSubmit(model)}
            schema={this.state.formModel.rules}
            ref={(ref: any) => this.form = ref}
        >
            <Comp.Editors.CheckboxField formComponent={this} name="active" />
            <Comp.Editors.CheckboxField formComponent={this} name="isAdmin" />
            <Comp.Editors.TextField formComponent={this} name="name" />

            <Comp.Editors.SelectField
                formComponent={this}
                name="parent"
                select={{
                    className: "txt-med",
                    options: this.props.parentGroups.map((x: M.Abstract.GradingGroup) => ({ label: x.name, value: x.id })).toArray(),
                    placeholder: "Select...",
                }}
            />

            <Comp.Editors.DatePickerField formComponent={this} name="opensOn" />
            <Comp.Editors.DatePickerField formComponent={this} name="closesOn" />

            <ReviewersEditor api={this.props.api} formComponent={this} />

            <Comp.Editors.SubmitField cancelLink={this.props.cancelLink} label="Save" showProcessing={this.state.formProcessing} />

        </Comp.Validation.ValidatedForm>;
    }

    private handleSubmit(model: Forms.Abstract.GradingGroupData) {
        const body = {
            active: model.active,
            closesOn: DateHelper.formatDateWithoutZone(moment(model.closesOn || new Date()).startOf("day").add(1439, "minutes").toDate()), // 23:59:00
            eventId: this.props.eventId,
            id: model.id,
            isAdmin: model.isAdmin,
            name: model.name,
            opensOn: DateHelper.formatDateWithoutZone(moment(model.opensOn || new Date()).startOf("day").toDate()),
            parentId: model.parent ? model.parent.value : null,
            reviewers: model.reviewers
                .filter((x) => !(x.userId === 0 && x.isDeleted))
                .map((x) => ({
                    isDeleted: x.isDeleted,
                    userId: x.userId,
                })),
        };

        console.log(body);

        this.props.onSubmit(model, body);
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/editGroup/EditGroupForm.tsx